import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * Componente para mostrar los datos fiscales de la orden
 */
const DatosFiscalesDisplay = ({
    datosFacturacion,
    esDistribuidor,
    onActualizar
}) => {
    return (
        <div className="fs--1">
            <p className="mt-2">Facturar esta orden con los siguientes datos fiscales:</p>
            <span className="radio-select-content form-check-label text-dark form-check">
                {datosFacturacion.vRfc} - {datosFacturacion.vRazonSocial}
                <br />

                {datosFacturacion.vNumRegTrib && (
                    <span className="d-block mb-0">
                        Núm. Reg. Trib.: {datosFacturacion.vNumRegTrib}
                    </span>
                )}

                {datosFacturacion.vDireccionFiscal} {'. '}
                {datosFacturacion.vEstadoDepProv} {', '}
                {datosFacturacion.vPais}.

                <span className="d-block mb-0">
                    C.P. |{datosFacturacion.vCp ? <span>{datosFacturacion.vCp}</span> : <span className="badge badge-soft-warning">Incompleto</span>}| 
                </span>

                <span className="d-block mb-0">
                    | {datosFacturacion.vTelefonoFacturacion} | {datosFacturacion.vTelefonoFacturacion} |
                </span>
                <span className="d-block mb-0">
                    EMAIL FACT: |{datosFacturacion.vEmailFacturacion ? <span>{datosFacturacion.vEmailFacturacion}</span> : <span className="badge badge-soft-warning">Incompleto</span>}|
                </span>
                <span className="d-block mb-0">
                    CÓD. PAÍS: |{datosFacturacion.vPaisFacturacion ?
                        <span>{datosFacturacion.vPaisFacturacion}</span> :
                        datosFacturacion.vRfc != 'XEXX010101000' ?
                            <span className="badge badge-soft-success">
                                <img src="/img/bandera-mexico-48.png" width="20"></img> MEXICANO</span> :
                            <span className="badge badge-soft-warning">Incompleto</span>}|
                </span>
                <span className="d-block mb-0">
                    {datosFacturacion.vCodigoRegimen} {datosFacturacion.vDescripcionRegimenFiscal}
                </span>

                <span className="d-block mb-0">
                    {datosFacturacion.vCodigoUso} {datosFacturacion.vDescripcionUsoCFDI}
                </span>

                {!esDistribuidor && esDistribuidor !== null && (
                    <>
                        <hr />
                        <Button
                            variant="outline-primary"
                            onClick={onActualizar}
                        >
                            Actualizar Datos Fiscales
                        </Button>
                    </>
                )}
            </span>
        </div>
    );
};

DatosFiscalesDisplay.propTypes = {
    datosFacturacion: PropTypes.shape({
        vRazonSocial: PropTypes.string,
        vRfc: PropTypes.string,
        vNumRegTrib: PropTypes.string,
        idCatUsoCFDI: PropTypes.number,
        idCatRegimenFiscal: PropTypes.number,
        vCp: PropTypes.string,
        vDireccionFiscal: PropTypes.string,
        vEstadoDepProv: PropTypes.string,
        vPais: PropTypes.string,
        vEmailFacturacion: PropTypes.string,
        vTelefonoFacturacion: PropTypes.string,
        vCodigoUso: PropTypes.string,
        vDescripcionUsoCFDI: PropTypes.string,
        vCodigoRegimen: PropTypes.string,
        vDescripcionRegimenFiscal: PropTypes.string,
        idDistribuidor: PropTypes.number,
        vPaisFacturacion: PropTypes.string
    }).isRequired,
    esDistribuidor: PropTypes.bool,
    onActualizar: PropTypes.func.isRequired
};

export default DatosFiscalesDisplay;
